import { FC, memo, useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox, useToasts } from '@brg/ui';
import { useProfile, bProfile } from '@brg/auth';
import { BookmarkAPI, Project, ProjectAPI, API, Endpoints, Card, Team, TeamAPI, Competition } from '@brg/api';
import { LayoutConst } from 'core/modules';

import { ProjectDesignerName } from '../projectDesignerName';
import { LikesBox } from '../likesBox';
import {ProjectCardSubTitle, ProjectCardTitle} from './styles';
import { ProjectCardTools } from './ProjectCardTools';
import { createCopyLinkProjectFn } from '../../helpers/copyLink';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import ProjectCardLayoutNew from './projectCardLayoutNew';
import { ProjectDelegate } from "../../../project-delegate";
import { useModal } from '../../../core'
import { IProjectLight } from "../../common";
import { ProjectEvents } from "../../helpers/projectEvents";
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { getProjectImages } from "../../pages/project/sections/ps-image";
import { useTranslation } from "react-i18next";
import { ProjectOnDisplay } from "../../helpers/projectStatus";
import { SOUND_ART_TAG_ID } from "../../constants/misc";
import { AppTester } from 'supporting';
import { PointBox } from '../pointBox/PointBox';
import { AlertBlock } from 'shared/icons/AlertBlock';
import { DeleteButton } from '../DeleteButton/DeleteButton';
import { BookmarkButton } from '../bookmarkButtonOnProject/BookmarkButton';
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/constants';
import { useGetShowcaseContext } from 'shared/hooks/useGetShowcaseContext';
import { RingPositions } from 'shared/constants/ringPositionType';
import {BookDelegate} from "../../../_deziiign/books/core/book-delegate";
import {getPresentationImages} from "../../helpers/utils/getPresentationImages";
import { isExpert, isExpertByPolicy } from 'shared/helpers/utils/TagsUtils';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { ProfileRole } from 'core/utils/bProfile';
import { extractIds } from 'shared/constants/extractIds';
import { useFoldersController } from 'shared/hooks/useFoldersController';
import { useDispatch, useSelector } from 'react-redux';
import ProfileFoldersSlice, { ProfileFoldersSelector } from 'shared/reducers/ProfileFoldersSlice';
import urlApi from 'shared/actions/urlApi';
import { Placement } from '../tooltips';
import RepostButton from '../repostButton/repostButton';
import { HiddenContentText } from './components/HiddenContentText';
import { useProjectCardPermissions } from './hooks/useProjectCardPermissions';
import { useProjectCardCompetition } from './hooks/useProjectCardCompetition';
import { useProjectCardBookmark } from './hooks/useProjectCardBookmark';

/** 
* Показать конкурсные баллы 
* @param showCompetitionPoint 
*/

export const SelectRing = styled(FlexBox)<{ active?: boolean, ringPosition?: RingPositions, disable?: boolean, incIdx?: boolean }>`
  background: rgba(24, 26, 28, 0.5);
  border: 2px solid #fefefe;
  backdrop-filter: blur(2px);
  box-sizing: border-box;

  ${({ incIdx }) => incIdx && css`
    z-index: 1;
  `};
  border-radius: 34px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: white;

  ${({ disable }) => disable && css`
    pointer-events: none;
  `}

  ${({ ringPosition }) => ringPosition ? css`
    margin: ${ringPosition === RingPositions.left ? '0 auto 0 0' : '0 0 0 auto'};
  ` : null};

  // @media(max-width: ${LayoutConst.screen.md}px) {
  //   z-index: 5;
  //   width: 24px;
  //   height: 24px;
  // }

  svg {
    outline: none !important;
  }

  ${p => p.active ? css`
    background: rgba(254, 254, 254, 1);
    border: 2px rgba(254, 254, 254, 1);
    box-sizing: border-box;
    border-radius: 34px;
  ` : null}
`;

export const Author = styled(FInter.SmallText)<{ hasBottomText?: boolean }>`
  @media (max-width: 940px) {
    div {
      font-weight: 400;
    }
  }

  ${({ hasBottomText }) => !hasBottomText && css`
    color: ${Colors.geoWhite100};
  `}
`

export interface ProjectCardDisplayProps {
  isLoading?: boolean;
  isOneColumn?: boolean;
  width?: string;
  height?: string;
  sizeMult?: number;
  rank?: number;
  metaAlwaysVisible?: boolean;
  isMobileMoreVisible?: boolean;
  projectType?: string;
  itemType?: string;
}

export interface ProjectCardSelectionProps {
  isSelectable?: boolean;
  isUnselectable?: boolean;
  selected?: boolean;
  isSelectRightNeed?: boolean;
  selectRingPosition?: RingPositions;
  alreadyProject?: boolean;
  editingProject?: boolean;
  onSelect?: (projectId: string) => void;
  onSelectProject?: (project: Project | undefined) => void;
}

export interface ProjectCardCompetitionProps {
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  isParticipant?: boolean;
  competition?: Competition<'Local'>;
}

export interface ProjectCardPermissionProps {
  isEditable?: boolean;
  isDeletable?: boolean;
  isCanNotParticipate?: boolean;
  isCanNotBeDraft?: boolean;
  isCanNotBeBookmark?: boolean;
  canMakeImageForTeam?: TOwnerRights;
}

export interface ProjectCardNavigationProps {
  linkPrefix?: string;
  linkTo?: string;
  withoutGoToProject?: boolean;
  openInModal?: boolean;
  useDirectNavigation?: boolean;
  isModal?: boolean;
  onProjectClick?: (projectId?: string, e?: any) => void;
}

export interface ProjectCardContentProps {
  project?: Project;
  isBook?: boolean;
  card?: Card;
  channel?: Team<'Global'>;
  isChannel?: boolean;
  entityType?: string;
  isRejected?: boolean;
  isRemovableFromBook?: boolean;
  isCert?: boolean;
}

export interface ProjectCardEventHandlers {
  onShouldReload?: (sender: any) => void;
  onRemoveFromBook?: (projectId: string) => void;
  onApprove?: (projectId: string) => void;
  onReject?: (projectId: string) => void;
  onUpdate?: () => void;
}

export interface ProjectCardNewProps extends 
  Partial<IProjectLight>, 
  ProjectEvents,
  ProjectCardDisplayProps,
  ProjectCardSelectionProps,
  ProjectCardCompetitionProps,
  ProjectCardPermissionProps,
  ProjectCardNavigationProps,
  ProjectCardContentProps,
  ProjectCardEventHandlers {
  tooltip?: ProjectTooltipProps;
  placement?: Placement;
  isCard?: boolean;
  withoutRepost?: boolean;
  dataKey?: any;
  showAnnotaions?: boolean;
}

const ProjectCardNew: FC<ProjectCardNewProps> = (props) => {
    const {
      isLoading,
      isSelectable,
      isUnselectable,
      isDeletable,
      isOneColumn,
      isRemovableFromBook,
      image,
      identifier,
      // channel,
      isChannel,
      entityType,
      title,
      likes,
      authors,
      author,
      coAuthors,
      isLiked,
      isEditable,
      isRejected,
      tooltip,
      width,
      height,
      selected,
      rank,
      isParticipant,
      useDirectNavigation,
      metaAlwaysVisible,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      isMobileMoreVisible,
      currentCompetitionId,
      withoutRepost,
      openInModal,
      onApprove,
      onReject,
      onSelect,
      onShouldReload,
      onProjectClick,
      onRemoveFromBook,
      isModal,
      project,
      placement,
      isBook,
      alreadyProject,
      editingProject,
      linkPrefix,
      isSelectRightNeed,
      selectRingPosition,
      sizeMult,
      withoutGoToProject,
      isCanNotParticipate,
      canMakeImageForTeam,
      projectType,
      isCanNotBeDraft,
      isCanNotBeBookmark,
      isCard,
      itemType,
      onUpdate,
      onSelectProject,
      isCert,
      card,
      linkTo,
      competition,
      showAnnotaions,
      ...handlers
    } = props;

    const history = useHistory();
    const profile = useProfile();
    const toasts = useToasts();
    const modal = useModal();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const isAgeyTomesh = AppTester.isAgeytomesh();
    const isOnlines = AppTester.isOnlines();
    const isMedia = AppTester.isMediiia();
    const isCompetitionProjectsPage = !!useRouteMatch('/competition/:id');
    const { id } = useParams<{ id: string }>();
    const [isReposted, setIsReposted] = useState<boolean>(false);
    const [pointVisible, setPoinVisible] = useState<boolean | null>(null);
    const [ showcaseContext ] = useGetShowcaseContext();
    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);

    const { foldersList } = useSelector(ProfileFoldersSelector)
    const { onRemoveProject } = useFoldersController();

    const isBanned = useMemo(() => project?.status === 3, [project])
    
    // @ts-ignore
    const hasBottomText = useMemo(() => project?.projectType === 'fixed-ratio-large', [project]);

    const calcProjectType = useMemo(() => {
      //@ts-ignore
      return project?.projectType || projectType
    } , [project])

    const presentationImages = getPresentationImages(project);

    const handlePointViewToggle = (flag: boolean) => {
      setPoinVisible(flag)
    }

    const handleToolTipToggleMove = useCallback((val: boolean) => {
      setTooltipOpen?.(val);
    } , [])

    const onProjectClickDefault = useCallback((projectId?: string, ev?: any): void => {
      if (!projectId || !ev) {
        return;
      }

      // disable navigation for bookmark btn
      if (ev.target.tagName === "rect" || ev.target.tagName === "svg" || ev.target.tagName === "path" || (ev.target.tagName === "DIV" && ev.target.className.includes("BookmarkButtonWrapper"))) {
        ev.preventDefault()
      }

      if (openInModal) {
        modal.show('project', { projectId });
      }

    }, [modal, openInModal]);

    const onDesignerSelected = useCallback(
      (designerId: string): void => history.push(CreateLinkTo.designer(designerId)),
      [history]
    );

    const onRemoveFromShowcase = useCallback((projectId: string): void => {
      
      if (!showcaseContext || showcaseContext === '') {
        return;
      }

      if (Array.isArray(showcaseContext)) {
        Promise.all(showcaseContext?.map((i) => (
          API.request()
          .endpoint(Endpoints.geograffee)
          .url(`/api/Project/UpdateContexts`)
          .post()
          .body({
            projectId: projectId,
            contexts: [{
              context: i,
              operation: 0,
            }],
          })
          .send()
        )))
        .then(() => {
          onShouldReload?.(projectId);
          toasts.info(t('toasts.removed_from_showcase', { name: title }));
        });
        return;
      }

      API.request()
      .endpoint(Endpoints.geograffee)
      .url(`/api/Project/UpdateContexts`)
      .post()
      .body({
        projectId: projectId,
        contexts: [{
          context: showcaseContext,
          operation: 0,
        }],
      })
      .send()
      .then(() => {
        onShouldReload?.(projectId);
        toasts.info(t('toasts.removed_from_showcase', { name: title }));
      });
    }, [onShouldReload, title, toasts, t, showcaseContext]);

    const isBookChapter = window.location.pathname.startsWith("/books/book-edit") || (AppTester.isBooksMain() && window.location.pathname.startsWith("/book-edit"));

    const {
      isEditableLocal,
      canBeDraft,
      isMe,
      isCreator,
      canEditFolders,
      isTagModer_Expert,
      isTagModer_ExpertByPolicy,
      hasEditProjectPolicy,
      isMoreVisible: isMoreVisibleFromPermissions,
    } = useProjectCardPermissions({
      project,
      isEditable,
      isSelectable,
      isCanNotParticipate,
      isCanNotBeDraft,
      isBookChapter,
    });

    const titleImages = useMemo(() => {
      if (getProjectImages(project, i18n.language)?.length > 0) {
        return getProjectImages(project, i18n.language)
      }
      return presentationImages
    } , [project, presentationImages, i18n])
    
    const isProjectOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    const isProjectPartInCompetition = useMemo(() =>
    //@ts-ignore
    (Boolean(project && !project?.canEdit_PartCompetition)), [project])
    const isProjectTitle = useMemo(() =>
    //@ts-ignore
    project?.additionalContent?.title?.text, [project])
    const projectSubTitle = useMemo(() =>
    //@ts-ignore
    project?.additionalContent?.subtitle?.text, [project])

    const isDefaultCoverVisible = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN) && !project?.titleImages?.length), [project])

    const isSelectedClick = (sel: boolean | undefined) => {
      return sel ? undefined : CreateLinkTo.projectNew(project) 
    }

    const onRemoveFromFolders = async (projectId: string) => {
      if (!foldersList?.length) return;

      const initFolders = async () => {
        const data = await urlApi().fetchFolders(profile?.designerId ?? '')

        if (Array.isArray(data)) {
          dispatch(ProfileFoldersSlice.actions.setFolders(data))
        };
      }

      const tFolder = foldersList?.find((folder) => folder?.entityIds?.includes(projectId))

      if (tFolder) {
        onRemoveProject({...tFolder, entityIds: [projectId]}).then((r) => {
          initFolders();
        })
      }
    }

    const projectIsOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    //@ts-ignore
    const isPresentation = useMemo(() => (project?.isPresentation),[project]);

    const onDraft = useCallback((projectId: string): void => {
      if (isProjectPartInCompetition) {
        toasts.error(t('toasts.project_part_competition'))
        return
      }
      if (handlers?.onMoveDrafts) {
        handlers.onMoveDrafts(projectId)
        return
      }
      const confirmation = window.confirm(t('project.confirmation_msg.to_drafts'));
      if (!confirmation) return;
      ProjectAPI.UpdateStatus({ projectStatus: 0, projectId }).then(() => {
        onRemoveFromFolders(projectId)
        onShouldReload?.(projectId);
        toasts.info(t("toasts.project_move_to_drafts_title", {
          title
        }));
      });
    }, [toasts, onShouldReload, title, isProjectPartInCompetition, handlers, t]);
    
    const { competitionGPA } = useProjectCardCompetition({
      project,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      currentCompetitionId,
      competition,
    });

    const shouldVisibleRemoveFromShowcase = useMemo(() => (
      !AppTester.isDvaDesign() && 
      !AppTester.isGeoMain() &&
      !AppTester.isAcademy() &&
      !AppTester.isDeziiignMain() &&
      !AppTester.isMediiia()
      ), []
    )

    const hidePrivateProject = useMemo(() => {
      return isChannel && !isParticipant && project?.status === 10
    } ,[isChannel, isParticipant, project])

    const backgroundStyles = useMemo(() => {
      if (hidePrivateProject) {
        return {
          background: 'linear-gradient( 180deg,rgba(0, 0, 0, 0),  rgba(24, 26, 28, 0.3), rgba(24, 26, 28, 1) )',
          backdropFilter: 'blur(25px)',
          marginTop: 0
        }
      }
      return undefined
    } , [hidePrivateProject])

    const backgroundText = useMemo(() => {
      if (hidePrivateProject) {
        return <HiddenContentText />
      }
      return undefined
    } , [hidePrivateProject])

    const { isBookmarked, handleBookmarkClick } = useProjectCardBookmark({
      project,
      onUpdate,
    });

    useEffect(() => {
      if (!project) return;
      //@ts-ignore
      setIsReposted(project?.isReposted || false);
    }, [project]);

      const isMoreVisible = isMoreVisibleFromPermissions;

      const isNominated = useMemo(() => {
        return !!project?.contexts?.includes('nomination')
      }, [project])

      const onNominationClick = useCallback(async () => {
        await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/UpdateContexts`)
        .post()
        .body({
          projectId: project?.projectId,
          contexts: [{
            context: 'nomination',
            operation: !isNominated? 1 : 0
          }],
        })
        .send()
        .then((res) => {
          if (res.status === 200) {
            const infoMsg = !isNominated? 'Проект номинирован на лучший проект месяца' : 'Проект снят с номинации'

            toasts.info(infoMsg);
          }
        }).catch((e) => {
          toasts.info('Ошибка запроса');
        })
      }, [isNominated, toasts, project])

      const tooltipProps = useMemo(() => {
        return {
          tooltipOpen: isTooltipOpen,
          toggleTooltip: handleToolTipToggleMove
        }
      } , [isTooltipOpen, handleToolTipToggleMove])

      if (hidePrivateProject) {
        return (
          <ProjectCardLayoutNew 
            title={''}
            linkTo={''}
            author={undefined}
            onClick={() => null}
            backgroundStyles={backgroundStyles}
            backgroundText={backgroundText}
            isMobileMoreVisible
            img={image}
            project={project}
            titleImages={titleImages}
            width={width}
            height={height}
            identifier={identifier}
            sizeMult={sizeMult}
            withoutGoToProject={true}
            itemType={itemType}
            projectType={calcProjectType}
          />
        )
      }

      return (
      <ProjectCardLayoutNew
        linkParams={showCompetitionJuryPoint && currentCompetitionId ? `?currentCompetitionId=${currentCompetitionId}` : ''}
        identifier={identifier}
        onClick={onProjectClick ?? onProjectClickDefault}
        img={image}
        backgroundStyles={backgroundStyles}
        project={project}
        titleImages={titleImages}
        isLoading={isLoading}
        width={width}
        linkTo={linkTo}
        height={height}
        isBook={isBook}
        rank={rank}
        isModal={isModal}
        href={isSelectedClick(selected)}
        hasBottomText={hasBottomText}
        title={<ProjectCardTitle>{isProjectTitle || title}</ProjectCardTitle>}
        subtitle={projectSubTitle ? <ProjectCardSubTitle>{projectSubTitle}</ProjectCardSubTitle> : undefined}
        isOneColumn={isOneColumn}
        isMoreVisible={isMoreVisible}
        isMobileMoreVisible={isMobileMoreVisible}
        isRejected={isRejected}
        metaAlwaysVisible={metaAlwaysVisible}
        {...tooltipProps}
        toggleViewPoint={handlePointViewToggle}
        linkPrefix={linkPrefix ? linkPrefix : undefined }
        isSelectRightNeed={isSelectRightNeed}
        sizeMult={sizeMult}
        withoutGoToProject={withoutGoToProject}
        itemType={itemType}
        projectType={calcProjectType}
        showAnnotaions={showAnnotaions}
        bookmarkButton={
          //@ts-ignore
          !isCompetitionProjectsPage && !isCard && !isBanned && (!isSelectable && <BookmarkButton type={project?.projectType === 't-shape'} isBookmarked={isBookmarked} onClick={handleBookmarkClick}/>)
        }
        repostButton={
          !isSelectable && !withoutRepost && !isBanned && project && profile && (
            <RepostButton 
              project={project} 
              iconOnPage 
              onUpdate={onShouldReload} 
            />
          )
        }
        more={
          (alreadyProject || editingProject) ? (
            <SelectRing active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} {...(isUnselectable && { onClick: (ev) => {
              if (onSelect) {
                ev.stopPropagation();
                ev.preventDefault();
                onSelect(identifier ?? '');
              }
            }})}>
                <div>
                  <svg
                    width="12"
                    height="10"
                    viewBox="0 0 12 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                   4.02557L1 4.85653Z"
                      fill="#151514"
                      stroke="#151514"
                    />
                  </svg>
                </div>
            </SelectRing>
          ) : isSelectable
            ? (
              <SelectRing className='selectRing' active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} onClick={(ev) => {
                if (onSelect) {
                  ev.stopPropagation();
                  ev.preventDefault();
                  onSelect(identifier ?? '');
                }
                if (onSelectProject) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onSelectProject(project);
                }
              }}>
                {selected && (
                  <div>
                    <svg
                      width="12"
                      height="10"
                      viewBox="0 0 12 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                     4.02557L1 4.85653Z"
                        fill="#151514"
                        stroke="#151514"
                      />
                    </svg>
                  </div>
                )}
              </SelectRing>
            )
            : isCard ? null : (
              <ProjectCardTools
                {...handlers}
                {...tooltipProps}
                placement={placement}
                isHiddenCancel={true}
                canViewStatistic={isTagModer_Expert}
                isCanBeDraft={canBeDraft && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                identifier={identifier}
                canAddBookmark={isCompetitionProjectsPage}
                isEditable={!isAgeyTomesh && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                isRemovableFromShowcase={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile) || hasEditProjectPolicy) && isProjectOnDisplay && shouldVisibleRemoveFromShowcase}
                isDeletable={isDeletable}
                canEditFolders={canEditFolders}
                isCopyLink={true}
                projectType={calcProjectType}
                isInOnDisplay={isProjectOnDisplay}
                isSuperModer={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))}
                //@ts-ignore
                isTagModerator={profile && (profile.tagListId?.some(x => project?.tagsID?.includes(x)) || profile.tagListId_Expert?.some(x => project?.tagsID?.includes(x)))}
                isTagExpert={isTagModer_Expert || isTagModer_ExpertByPolicy}
                isNominated={isNominated}
                onNominationClick={onNominationClick}
                isTeamOwner={canMakeImageForTeam?.canMake}
                onMoveFromShowcase={onRemoveFromShowcase}
                onCopyLink={createCopyLinkProjectFn(toasts, t)}
                onMoveDrafts={onDraft}
                isPresentation={isPresentation}
                toggleTooltip={handleToolTipToggleMove}
                isCoauthor={profile && project?.coAuthorIds?.includes(profile?.accountId)}
                onAddBookmark={handleBookmarkClick}
                onRejectCoauthor={() => {
                  const confirmation = window.confirm('Вы действительно хотите отказаться от соавторства?');
                  if (confirmation) {
                    API.request()
                        .endpoint(Endpoints.geograffee)
                        .url('/api/Project/RefuseCoAuthorship')
                        .post()
                        .body({
                            projectId: project?.projectId || ''
                        })
                        .release()
                        .then((r: any) => {
                            if (r.status === 400 || r.status === 500) {
                                toasts.error(t('toasts.project_reject_coauthor_error'))
                                return;
                            }
                            toasts.info(t('toasts.project_reject_coauthor'))

                            setTimeout(() => window.location.reload(), 1500)
                        })
                        .catch((e: any) => toasts.error(t('toasts.project_reject_coauthor_error')))
                      }
                }}
                onMakeImageForOrganization={(projectId) => {
                  if (canMakeImageForTeam?.canMake) {
                    const confirmation = window.confirm('Сделать изображение обложкой юнита?');
                    if (confirmation) {
                      API.request()
                      .endpoint(Endpoints.geograffee)
                      .url('/api/Team/CopyTitleFromProject')
                      .post()
                      .body({
                        teamId: canMakeImageForTeam.teamId,
                        projectId
                      })
                      .release()
                      .then((r: Response) => {
                        toasts.info('Успешно');
                      })
                      window.location.reload();
                    }
                  }
                 }} 
                onMakeBilingual={(projectId) => {
                  const confirmation = window.confirm('Вы действительно хотите сделать проект двуязычным?')
                  if (confirmation) {
                    history.push(CreateLinkTo.bilingual(projectId))
                  }
                }}
                  //@ts-ignore
                canMakeBilingual={!project?.isBilingual && !project?.longreadId_en
                && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
                && !(projectIsOnDisplay && !(profile && bProfile.isModer(profile)) && !hasEditProjectPolicy)
                &&  !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                {...(tooltip ?? {})}
                project={project}
                linkPrefix={linkPrefix ? linkPrefix : undefined }
                isCanNotParticipate={isCanNotParticipate}
                isPartInCompetition={isProjectPartInCompetition}
                isBookmarked={isBookmarked}
              />
            )
        }
        author={
          !isOnlines && (
            <Author hasBottomText={hasBottomText} >
            <ProjectDesignerName
              value={author ? [author].concat(coAuthors ?? []) : (coAuthors ?? [])}
              onSelected={onDesignerSelected}
              isBlackTheme={isDefaultCoverVisible}
              //@ts-ignore
              projectType={project?.projectType || projectType}
            />
          </Author>
          )
        }
        likes={
          !isOnlines && !isCard && (
            <LikesBox isBlackTheme={isDefaultCoverVisible} likes={project?.quPersonCount ?? likes ?? 0} isLiked={isLiked} isInteractive onClick={() => history.push(CreateLinkTo.projectNew(project))}/>
          )
        }
        point={
    // @ts-ignore
          ((showFirstCompetitionPoint || showCompetitionPoint) && !isOnlines) && <PointBox points={competitionGPA} textVisible={pointVisible} />
        }
        status={<AlertBlock />}
        deleteButton={
          <DeleteButton 
            onClick={() =>onRemoveFromBook && onRemoveFromBook(props?.project?.projectId ?? '')} 
          />
        }
        isRemovableFromBook={isRemovableFromBook}
        isCert={isCert}
        card={card}
      />
    );
  }
;

export default memo(ProjectCardNew);
import { FC, memo, useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox, useToasts } from '@brg/ui';
import { useProfile, bProfile } from '@brg/auth';
import { BookmarkAPI, Project, ProjectAPI, API, Endpoints, Card, Team, TeamAPI, Competition } from '@brg/api';
import { LayoutConst } from 'core/modules';

import { ProjectDesignerName } from '../projectDesignerName';
import { LikesBox } from '../likesBox';
import {ProjectCardSubTitle, ProjectCardTitle} from './styles';
import { ProjectCardTools } from './ProjectCardTools';
import { createCopyLinkProjectFn } from '../../helpers/copyLink';
import { CreateLinkTo, LinkTo } from '../../constants/linkTo';
import ProjectCardLayoutNew from './projectCardLayoutNew';
import { ProjectDelegate } from "../../../project-delegate";
import { useModal } from '../../../core'
import { IProjectLight } from "../../common";
import { ProjectEvents } from "../../helpers/projectEvents";
import { ProjectTooltipProps } from '../tooltips/ProjectTooltip';
import { getProjectImages } from "../../pages/project/sections/ps-image";
import { useTranslation } from "react-i18next";
import { ProjectOnDisplay } from "../../helpers/projectStatus";
import { SOUND_ART_TAG_ID } from "../../constants/misc";
import { AppTester } from 'supporting';
import { PointBox } from '../pointBox/PointBox';
import { AlertBlock } from 'shared/icons/AlertBlock';
import { DeleteButton } from '../DeleteButton/DeleteButton';
import { BookmarkButton } from '../bookmarkButtonOnProject/BookmarkButton';
import { TOwnerRights } from 'shared/pages/exploreHseContextsNew/exploreHseContextsNew';
import { SP_VOTE_COLLECTION_SIGN } from 'shared/pages/VotesAdmin/constants';
import { useGetShowcaseContext } from 'shared/hooks/useGetShowcaseContext';
import { RingPositions } from 'shared/constants/ringPositionType';
import {BookDelegate} from "../../../_deziiign/books/core/book-delegate";
import {getPresentationImages} from "../../helpers/utils/getPresentationImages";
import { isExpert, isExpertByPolicy } from 'shared/helpers/utils/TagsUtils';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { ProfileRole } from 'core/utils/bProfile';
import { extractIds } from 'shared/constants/extractIds';
import { useFoldersController } from 'shared/hooks/useFoldersController';
import { useDispatch, useSelector } from 'react-redux';
import ProfileFoldersSlice, { ProfileFoldersSelector } from 'shared/reducers/ProfileFoldersSlice';
import urlApi from 'shared/actions/urlApi';
import { Placement } from '../tooltips';
import RepostButton from '../repostButton/repostButton';
import { HiddenContentText } from './components/HiddenContentText';
import { useProjectCardPermissions } from './hooks/useProjectCardPermissions';
import { useProjectCardCompetition } from './hooks/useProjectCardCompetition';
import { useProjectCardBookmark } from './hooks/useProjectCardBookmark';

/** 
* Показать конкурсные баллы 
* @param showCompetitionPoint 
*/

export const SelectRing = styled(FlexBox)<{ active?: boolean, ringPosition?: RingPositions, disable?: boolean, incIdx?: boolean }>`
  background: rgba(24, 26, 28, 0.5);
  border: 2px solid #fefefe;
  backdrop-filter: blur(2px);
  box-sizing: border-box;

  ${({ incIdx }) => incIdx && css`
    z-index: 1;
  `};
  border-radius: 34px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  color: white;

  ${({ disable }) => disable && css`
    pointer-events: none;
  `}

  ${({ ringPosition }) => ringPosition ? css`
    margin: ${ringPosition === RingPositions.left ? '0 auto 0 0' : '0 0 0 auto'};
  ` : null};

  // @media(max-width: ${LayoutConst.screen.md}px) {
  //   z-index: 5;
  //   width: 24px;
  //   height: 24px;
  // }

  svg {
    outline: none !important;
  }

  ${p => p.active ? css`
    background: rgba(254, 254, 254, 1);
    border: 2px rgba(254, 254, 254, 1);
    box-sizing: border-box;
    border-radius: 34px;
  ` : null}
`;

export const Author = styled(FInter.SmallText)<{ hasBottomText?: boolean }>`
  @media (max-width: 940px) {
    div {
      font-weight: 400;
    }
  }

  ${({ hasBottomText }) => !hasBottomText && css`
    color: ${Colors.geoWhite100};
  `}
`

export interface ProjectCardDisplayProps {
  isLoading?: boolean;
  isOneColumn?: boolean;
  width?: string;
  height?: string;
  sizeMult?: number;
  rank?: number;
  metaAlwaysVisible?: boolean;
  isMobileMoreVisible?: boolean;
  projectType?: string;
  itemType?: string;
}

export interface ProjectCardSelectionProps {
  isSelectable?: boolean;
  isUnselectable?: boolean;
  selected?: boolean;
  isSelectRightNeed?: boolean;
  selectRingPosition?: RingPositions;
  alreadyProject?: boolean;
  editingProject?: boolean;
  onSelect?: (projectId: string) => void;
  onSelectProject?: (project: Project | undefined) => void;
}

export interface ProjectCardCompetitionProps {
  showCompetitionPoint?: boolean;
  showCompetitionJuryPoint?: boolean;
  showFirstCompetitionPoint?: boolean;
  currentCompetitionId?: string;
  isParticipant?: boolean;
  competition?: Competition<'Local'>;
}

export interface ProjectCardPermissionProps {
  isEditable?: boolean;
  isDeletable?: boolean;
  isCanNotParticipate?: boolean;
  isCanNotBeDraft?: boolean;
  isCanNotBeBookmark?: boolean;
  canMakeImageForTeam?: TOwnerRights;
}

export interface ProjectCardNavigationProps {
  linkPrefix?: string;
  linkTo?: string;
  withoutGoToProject?: boolean;
  openInModal?: boolean;
  useDirectNavigation?: boolean;
  isModal?: boolean;
  onProjectClick?: (projectId?: string, e?: any) => void;
}

export interface ProjectCardContentProps {
  project?: Project;
  isBook?: boolean;
  card?: Card;
  channel?: Team<'Global'>;
  isChannel?: boolean;
  entityType?: string;
  isRejected?: boolean;
  isRemovableFromBook?: boolean;
  isCert?: boolean;
}

export interface ProjectCardEventHandlers {
  onShouldReload?: (sender: any) => void;
  onRemoveFromBook?: (projectId: string) => void;
  onApprove?: (projectId: string) => void;
  onReject?: (projectId: string) => void;
  onUpdate?: () => void;
}

export interface ProjectCardNewProps extends 
  Partial<IProjectLight>, 
  ProjectEvents,
  ProjectCardDisplayProps,
  ProjectCardSelectionProps,
  ProjectCardCompetitionProps,
  ProjectCardPermissionProps,
  ProjectCardNavigationProps,
  ProjectCardContentProps,
  ProjectCardEventHandlers {
  tooltip?: ProjectTooltipProps;
  placement?: Placement;
  isCard?: boolean;
  withoutRepost?: boolean;
  dataKey?: any;
  showAnnotaions?: boolean;
}

const ProjectCardNew: FC<ProjectCardNewProps> = (props) => {
    const {
      isLoading,
      isSelectable,
      isUnselectable,
      isDeletable,
      isOneColumn,
      isRemovableFromBook,
      image,
      identifier,
      // channel,
      isChannel,
      entityType,
      title,
      likes,
      authors,
      author,
      coAuthors,
      isLiked,
      isEditable,
      isRejected,
      tooltip,
      width,
      height,
      selected,
      rank,
      isParticipant,
      useDirectNavigation,
      metaAlwaysVisible,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      isMobileMoreVisible,
      currentCompetitionId,
      withoutRepost,
      openInModal,
      onApprove,
      onReject,
      onSelect,
      onShouldReload,
      onProjectClick,
      onRemoveFromBook,
      isModal,
      project,
      placement,
      isBook,
      alreadyProject,
      editingProject,
      linkPrefix,
      isSelectRightNeed,
      selectRingPosition,
      sizeMult,
      withoutGoToProject,
      isCanNotParticipate,
      canMakeImageForTeam,
      projectType,
      isCanNotBeDraft,
      isCanNotBeBookmark,
      isCard,
      itemType,
      onUpdate,
      onSelectProject,
      isCert,
      card,
      linkTo,
      competition,
      showAnnotaions,
      ...handlers
    } = props;

    const history = useHistory();
    const profile = useProfile();
    const toasts = useToasts();
    const modal = useModal();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const isAgeyTomesh = AppTester.isAgeytomesh();
    const isOnlines = AppTester.isOnlines();
    const isMedia = AppTester.isMediiia();
    const isCompetitionProjectsPage = !!useRouteMatch('/competition/:id');
    const { id } = useParams<{ id: string }>();
    const [isReposted, setIsReposted] = useState<boolean>(false);
    const [pointVisible, setPoinVisible] = useState<boolean | null>(null);
    const [ showcaseContext ] = useGetShowcaseContext();
    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);

    const { foldersList } = useSelector(ProfileFoldersSelector)
    const { onRemoveProject } = useFoldersController();

    const isBanned = useMemo(() => project?.status === 3, [project])
    
    // @ts-ignore
    const hasBottomText = useMemo(() => project?.projectType === 'fixed-ratio-large', [project]);

    const calcProjectType = useMemo(() => {
      //@ts-ignore
      return project?.projectType || projectType
    } , [project])

    const presentationImages = getPresentationImages(project);

    const handlePointViewToggle = (flag: boolean) => {
      setPoinVisible(flag)
    }

    const handleToolTipToggleMove = useCallback((val: boolean) => {
      setTooltipOpen?.(val);
    } , [])

    const onProjectClickDefault = useCallback((projectId?: string, ev?: any): void => {
      if (!projectId || !ev) {
        return;
      }

      // disable navigation for bookmark btn
      if (ev.target.tagName === "rect" || ev.target.tagName === "svg" || ev.target.tagName === "path" || (ev.target.tagName === "DIV" && ev.target.className.includes("BookmarkButtonWrapper"))) {
        ev.preventDefault()
      }

      if (openInModal) {
        modal.show('project', { projectId });
      }

    }, [modal, openInModal]);

    const onDesignerSelected = useCallback(
      (designerId: string): void => history.push(CreateLinkTo.designer(designerId)),
      [history]
    );

    const onRemoveFromShowcase = useCallback((projectId: string): void => {
      
      if (!showcaseContext || showcaseContext === '') {
        return;
      }

      if (Array.isArray(showcaseContext)) {
        Promise.all(showcaseContext?.map((i) => (
          API.request()
          .endpoint(Endpoints.geograffee)
          .url(`/api/Project/UpdateContexts`)
          .post()
          .body({
            projectId: projectId,
            contexts: [{
              context: i,
              operation: 0,
            }],
          })
          .send()
        )))
        .then(() => {
          onShouldReload?.(projectId);
          toasts.info(t('toasts.removed_from_showcase', { name: title }));
        });
        return;
      }

      API.request()
      .endpoint(Endpoints.geograffee)
      .url(`/api/Project/UpdateContexts`)
      .post()
      .body({
        projectId: projectId,
        contexts: [{
          context: showcaseContext,
          operation: 0,
        }],
      })
      .send()
      .then(() => {
        onShouldReload?.(projectId);
        toasts.info(t('toasts.removed_from_showcase', { name: title }));
      });
    }, [onShouldReload, title, toasts, t, showcaseContext]);

    const isBookChapter = window.location.pathname.startsWith("/books/book-edit") || (AppTester.isBooksMain() && window.location.pathname.startsWith("/book-edit"));

    const {
      isEditableLocal,
      canBeDraft,
      isMe,
      isCreator,
      canEditFolders,
      isTagModer_Expert,
      isTagModer_ExpertByPolicy,
      hasEditProjectPolicy,
      isMoreVisible: isMoreVisibleFromPermissions,
    } = useProjectCardPermissions({
      project,
      isEditable,
      isSelectable,
      isCanNotParticipate,
      isCanNotBeDraft,
      isBookChapter,
    });

    const titleImages = useMemo(() => {
      if (getProjectImages(project, i18n.language)?.length > 0) {
        return getProjectImages(project, i18n.language)
      }
      return presentationImages
    } , [project, presentationImages, i18n])
    
    const isProjectOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    const isProjectPartInCompetition = useMemo(() =>
    //@ts-ignore
    (Boolean(project && !project?.canEdit_PartCompetition)), [project])
    const isProjectTitle = useMemo(() =>
    //@ts-ignore
    project?.additionalContent?.title?.text, [project])
    const projectSubTitle = useMemo(() =>
    //@ts-ignore
    project?.additionalContent?.subtitle?.text, [project])

    const isDefaultCoverVisible = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN) && !project?.titleImages?.length), [project])

    const isSelectedClick = (sel: boolean | undefined) => {
      return sel ? undefined : CreateLinkTo.projectNew(project) 
    }

    const onRemoveFromFolders = async (projectId: string) => {
      if (!foldersList?.length) return;

      const initFolders = async () => {
        const data = await urlApi().fetchFolders(profile?.designerId ?? '')

        if (Array.isArray(data)) {
          dispatch(ProfileFoldersSlice.actions.setFolders(data))
        };
      }

      const tFolder = foldersList?.find((folder) => folder?.entityIds?.includes(projectId))

      if (tFolder) {
        onRemoveProject({...tFolder, entityIds: [projectId]}).then((r) => {
          initFolders();
        })
      }
    }

    const projectIsOnDisplay = useMemo(() =>
      project && ProjectOnDisplay(project),[project])

    //@ts-ignore
    const isPresentation = useMemo(() => (project?.isPresentation),[project]);

    const onDraft = useCallback((projectId: string): void => {
      if (isProjectPartInCompetition) {
        toasts.error(t('toasts.project_part_competition'))
        return
      }
      if (handlers?.onMoveDrafts) {
        handlers.onMoveDrafts(projectId)
        return
      }
      const confirmation = window.confirm(t('project.confirmation_msg.to_drafts'));
      if (!confirmation) return;
      ProjectAPI.UpdateStatus({ projectStatus: 0, projectId }).then(() => {
        onRemoveFromFolders(projectId)
        onShouldReload?.(projectId);
        toasts.info(t("toasts.project_move_to_drafts_title", {
          title
        }));
      });
    }, [toasts, onShouldReload, title, isProjectPartInCompetition, handlers, t]);
    
    const { competitionGPA } = useProjectCardCompetition({
      project,
      showCompetitionPoint,
      showCompetitionJuryPoint,
      showFirstCompetitionPoint,
      currentCompetitionId,
      competition,
    });

    const shouldVisibleRemoveFromShowcase = useMemo(() => (
      !AppTester.isDvaDesign() && 
      !AppTester.isGeoMain() &&
      !AppTester.isAcademy() &&
      !AppTester.isDeziiignMain() &&
      !AppTester.isMediiia()
      ), []
    )

    const hidePrivateProject = useMemo(() => {
      return isChannel && !isParticipant && project?.status === 10
    } ,[isChannel, isParticipant, project])

    const backgroundStyles = useMemo(() => {
      if (hidePrivateProject) {
        return {
          background: 'linear-gradient( 180deg,rgba(0, 0, 0, 0),  rgba(24, 26, 28, 0.3), rgba(24, 26, 28, 1) )',
          backdropFilter: 'blur(25px)',
          marginTop: 0
        }
      }
      return undefined
    } , [hidePrivateProject])

    const backgroundText = useMemo(() => {
      if (hidePrivateProject) {
        return <HiddenContentText />
      }
      return undefined
    } , [hidePrivateProject])

    const { isBookmarked, handleBookmarkClick } = useProjectCardBookmark({
      project,
      onUpdate,
    });

    useEffect(() => {
      if (!project) return;
      //@ts-ignore
      setIsReposted(project?.isReposted || false);
    }, [project]);

      const isMoreVisible = isMoreVisibleFromPermissions;

      const isNominated = useMemo(() => {
        return !!project?.contexts?.includes('nomination')
      }, [project])

      const onNominationClick = useCallback(async () => {
        await API.request()
        .endpoint(Endpoints.geograffee)
        .url(`/api/Project/UpdateContexts`)
        .post()
        .body({
          projectId: project?.projectId,
          contexts: [{
            context: 'nomination',
            operation: !isNominated? 1 : 0
          }],
        })
        .send()
        .then((res) => {
          if (res.status === 200) {
            const infoMsg = !isNominated? 'Проект номинирован на лучший проект месяца' : 'Проект снят с номинации'

            toasts.info(infoMsg);
          }
        }).catch((e) => {
          toasts.info('Ошибка запроса');
        })
      }, [isNominated, toasts, project])

      const tooltipProps = useMemo(() => {
        return {
          tooltipOpen: isTooltipOpen,
          toggleTooltip: handleToolTipToggleMove
        }
      } , [isTooltipOpen, handleToolTipToggleMove])

      if (hidePrivateProject) {
        return (
          <ProjectCardLayoutNew 
            title={''}
            linkTo={''}
            author={undefined}
            onClick={() => null}
            backgroundStyles={backgroundStyles}
            backgroundText={backgroundText}
            isMobileMoreVisible
            img={image}
            project={project}
            titleImages={titleImages}
            width={width}
            height={height}
            identifier={identifier}
            sizeMult={sizeMult}
            withoutGoToProject={true}
            itemType={itemType}
            projectType={calcProjectType}
          />
        )
      }

      return (
      <ProjectCardLayoutNew
        linkParams={showCompetitionJuryPoint && currentCompetitionId ? `?currentCompetitionId=${currentCompetitionId}` : ''}
        identifier={identifier}
        onClick={onProjectClick ?? onProjectClickDefault}
        img={image}
        backgroundStyles={backgroundStyles}
        project={project}
        titleImages={titleImages}
        isLoading={isLoading}
        width={width}
        linkTo={linkTo}
        height={height}
        isBook={isBook}
        rank={rank}
        isModal={isModal}
        href={isSelectedClick(selected)}
        hasBottomText={hasBottomText}
        title={<ProjectCardTitle>{isProjectTitle || title}</ProjectCardTitle>}
        subtitle={projectSubTitle ? <ProjectCardSubTitle>{projectSubTitle}</ProjectCardSubTitle> : undefined}
        isOneColumn={isOneColumn}
        isMoreVisible={isMoreVisible}
        isMobileMoreVisible={isMobileMoreVisible}
        isRejected={isRejected}
        metaAlwaysVisible={metaAlwaysVisible}
        {...tooltipProps}
        toggleViewPoint={handlePointViewToggle}
        linkPrefix={linkPrefix ? linkPrefix : undefined }
        isSelectRightNeed={isSelectRightNeed}
        sizeMult={sizeMult}
        withoutGoToProject={withoutGoToProject}
        itemType={itemType}
        projectType={calcProjectType}
        showAnnotaions={showAnnotaions}
        bookmarkButton={
          //@ts-ignore
          !isCompetitionProjectsPage && !isCard && !isBanned && (!isSelectable && <BookmarkButton type={project?.projectType === 't-shape'} isBookmarked={isBookmarked} onClick={handleBookmarkClick}/>)
        }
        repostButton={
          !isSelectable && !withoutRepost && !isBanned && project && profile && (
            <RepostButton 
              project={project} 
              iconOnPage 
              onUpdate={onShouldReload} 
            />
          )
        }
        more={
          (alreadyProject || editingProject) ? (
            <SelectRing active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} {...(isUnselectable && { onClick: (ev) => {
              if (onSelect) {
                ev.stopPropagation();
                ev.preventDefault();
                onSelect(identifier ?? '');
              }
            }})}>
                <div>
                  <svg
                    width="12"
                    height="10"
                    viewBox="0 0 12 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                   4.02557L1 4.85653Z"
                      fill="#151514"
                      stroke="#151514"
                    />
                  </svg>
                </div>
            </SelectRing>
          ) : isSelectable
            ? (
              <SelectRing className='selectRing' active={selected} ringPosition={selectRingPosition} incIdx={!!showCompetitionPoint} onClick={(ev) => {
                if (onSelect) {
                  ev.stopPropagation();
                  ev.preventDefault();
                  onSelect(identifier ?? '');
                }
                if (onSelectProject) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onSelectProject(project);
                }
              }}>
                {selected && (
                  <div>
                    <svg
                      width="12"
                      height="10"
                      viewBox="0 0 12 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                     4.02557L1 4.85653Z"
                        fill="#151514"
                        stroke="#151514"
                      />
                    </svg>
                  </div>
                )}
              </SelectRing>
            )
            : isCard ? null : (
              <ProjectCardTools
                {...handlers}
                {...tooltipProps}
                placement={placement}
                isHiddenCancel={true}
                canViewStatistic={isTagModer_Expert}
                isCanBeDraft={canBeDraft && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                identifier={identifier}
                canAddBookmark={isCompetitionProjectsPage}
                isEditable={!isAgeyTomesh && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project)) && !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                isRemovableFromShowcase={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile) || hasEditProjectPolicy) && isProjectOnDisplay && shouldVisibleRemoveFromShowcase}
                isDeletable={isDeletable}
                canEditFolders={canEditFolders}
                isCopyLink={true}
                projectType={calcProjectType}
                isInOnDisplay={isProjectOnDisplay}
                isSuperModer={profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile))}
                //@ts-ignore
                isTagModerator={profile && (profile.tagListId?.some(x => project?.tagsID?.includes(x)) || profile.tagListId_Expert?.some(x => project?.tagsID?.includes(x)))}
                isTagExpert={isTagModer_Expert || isTagModer_ExpertByPolicy}
                isNominated={isNominated}
                onNominationClick={onNominationClick}
                isTeamOwner={canMakeImageForTeam?.canMake}
                onMoveFromShowcase={onRemoveFromShowcase}
                onCopyLink={createCopyLinkProjectFn(toasts, t)}
                onMoveDrafts={onDraft}
                isPresentation={isPresentation}
                toggleTooltip={handleToolTipToggleMove}
                isCoauthor={profile && project?.coAuthorIds?.includes(profile?.accountId)}
                onAddBookmark={handleBookmarkClick}
                onRejectCoauthor={() => {
                  const confirmation = window.confirm('Вы действительно хотите отказаться от соавторства?');
                  if (confirmation) {
                    API.request()
                        .endpoint(Endpoints.geograffee)
                        .url('/api/Project/RefuseCoAuthorship')
                        .post()
                        .body({
                            projectId: project?.projectId || ''
                        })
                        .release()
                        .then((r: any) => {
                            if (r.status === 400 || r.status === 500) {
                                toasts.error(t('toasts.project_reject_coauthor_error'))
                                return;
                            }
                            toasts.info(t('toasts.project_reject_coauthor'))

                            setTimeout(() => window.location.reload(), 1500)
                        })
                        .catch((e: any) => toasts.error(t('toasts.project_reject_coauthor_error')))
                      }
                }}
                onMakeImageForOrganization={(projectId) => {
                  if (canMakeImageForTeam?.canMake) {
                    const confirmation = window.confirm('Сделать изображение обложкой юнита?');
                    if (confirmation) {
                      API.request()
                      .endpoint(Endpoints.geograffee)
                      .url('/api/Team/CopyTitleFromProject')
                      .post()
                      .body({
                        teamId: canMakeImageForTeam.teamId,
                        projectId
                      })
                      .release()
                      .then((r: Response) => {
                        toasts.info('Успешно');
                      })
                      window.location.reload();
                    }
                  }
                 }} 
                onMakeBilingual={(projectId) => {
                  const confirmation = window.confirm('Вы действительно хотите сделать проект двуязычным?')
                  if (confirmation) {
                    history.push(CreateLinkTo.bilingual(projectId))
                  }
                }}
                  //@ts-ignore
                canMakeBilingual={!project?.isBilingual && !project?.longreadId_en
                && (isCreator || isMe || ProjectDelegate.isProjectEditableFor(profile, project))
                && !(projectIsOnDisplay && !(profile && bProfile.isModer(profile)) && !hasEditProjectPolicy)
                &&  !isCanNotParticipate && !BookDelegate?.isPaid(project)}
                {...(tooltip ?? {})}
                project={project}
                linkPrefix={linkPrefix ? linkPrefix : undefined }
                isCanNotParticipate={isCanNotParticipate}
                isPartInCompetition={isProjectPartInCompetition}
                isBookmarked={isBookmarked}
              />
            )
        }
        author={
          !isOnlines && (
            <Author hasBottomText={hasBottomText} >
            <ProjectDesignerName
              value={author ? [author].concat(coAuthors ?? []) : (coAuthors ?? [])}
              onSelected={onDesignerSelected}
              isBlackTheme={isDefaultCoverVisible}
              //@ts-ignore
              projectType={project?.projectType || projectType}
            />
          </Author>
          )
        }
        likes={
          !isOnlines && !isCard && (
            <LikesBox isBlackTheme={isDefaultCoverVisible} likes={project?.quPersonCount ?? likes ?? 0} isLiked={isLiked} isInteractive onClick={() => history.push(CreateLinkTo.projectNew(project))}/>
          )
        }
        point={
    // @ts-ignore
          ((showFirstCompetitionPoint || showCompetitionPoint) && !isOnlines) && <PointBox points={competitionGPA} textVisible={pointVisible} />
        }
        status={<AlertBlock />}
        deleteButton={
          <DeleteButton 
            onClick={() =>onRemoveFromBook && onRemoveFromBook(props?.project?.projectId ?? '')} 
          />
        }
        isRemovableFromBook={isRemovableFromBook}
        isCert={isCert}
        card={card}
      />
    );
  }
;

export default memo(ProjectCardNew);
